module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-link"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('div', [(_vm.productCategories.length < 1) ? _c('div', [_vm._v("\n            This product does not belong to a category\n            "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productCategories), function(category) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'category',
          params: {
            id: category.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(category.name) + "\n            ")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.remove(category)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_vm._v("Add to category...")])]) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "name": "category-add"
    },
    on: {
      "change": function($event) {
        return _vm.add($event.target.value)
      }
    }
  }, [_c('option', [_vm._v("Select a category...")]), _vm._v(" "), _vm._l((_vm.availableCategories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adding = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa606332"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/products/ProductCategories.vue
// module id = 588
// module chunks = 0